import React from 'react';

import { StatusBar, View, Animated } from 'react-native';
import AppIntro from 'react-native-app-intro';
import DoneButton from 'react-native-app-intro/components/DoneButton';
import SkipButton from './SkipButton';
import RenderDots from 'react-native-app-intro/components/Dots';
import { WINDOW_HEIGHT } from '../components/styleConstants';
import Swiper from './SwiperWeb';

export default class AppIntroWrapper extends AppIntro {
  renderPagination = (index, total, context) => {
    let isDoneBtnShow;
    let isSkipBtnShow;
    if (index === total - 1) {
      this.setDoneBtnOpacity(1);
      this.setSkipBtnOpacity(0);
      this.setNextOpacity(0);
      isDoneBtnShow = true;
      isSkipBtnShow = false;
    } else {
      this.setDoneBtnOpacity(0);
      this.setSkipBtnOpacity(1);
      this.setNextOpacity(1);
      isDoneBtnShow = false;
      isSkipBtnShow = true;
    }
    return (
      <View
        style={[
          {
            position: 'absolute',
            top: WINDOW_HEIGHT - 180,
            flexDirection: 'row',
            flex: 1,
            width: this.props.videoWidth,
            justifyContent: 'center',
            alignItems: 'center',
          },
        ]}
      >
        {this.props.showSkipButton ? (
          <View
            style={{
              width: 70,
            }}
          >
            <SkipButton
              {...this.props}
              {...this.state}
              testID="skip"
              isSkipBtnShow={isSkipBtnShow}
              styles={this.styles}
              onSkipBtnClick={() => this.props.onSkipBtnClick(index)}
            />
          </View>
        ) : (
          <View style={this.styles.btnContainer} />
        )}
        {this.props.showDots && (
          <View
            style={{
              marginBottom: -3,
              paddingRight: 15,
              paddingLeft: 25,
              flexDirection: 'row',
            }}
          >
            {RenderDots(index, total, {
              ...this.props,
              styles: this.styles,
            })}
          </View>
        )}
        {this.props.showDoneButton ? (
          <DoneButton
            {...this.props}
            {...this.state}
            isDoneBtnShow={isDoneBtnShow}
            styles={this.styles}
            onNextBtnClick={this.onNextBtnClick.bind(this, context)}
            onDoneBtnClick={this.props.onDoneBtnClick}
          />
        ) : (
          <View style={this.styles.btnContainer} />
        )}
      </View>
    );
  };
  onNextBtnClick = (context) => {
    if (context.state.isScrolling || context.state.total < 2) return;
    const { state } = context;
    const diff = (context.props.loop ? 1 : 0) + 1 + context.state.index;
    let x = 0;
    if (state.dir === 'x') x = diff * state.width;

    context.refs.scrollView.scrollTo({ y: 0, x });
    this.props.onSlideChange(context.state.index + 1, context.state.total);

    this.props.onNextBtnClick(context.state.index);
  };

  render() {
    const childrens = this.props.children;
    const { pageArray } = this.props;
    let pages = [];
    if (pageArray.length > 0) {
      pages = pageArray.map((page, i) => this.renderBasicSlidePage(i, page));
    } else {
      pages = childrens.map((children, i) => this.renderChild(children, i, i));
    }

    return (
      <View style={{ position: 'static' }}>
        <Swiper
          loop={false}
          width={960}
          height="100vh"
          index={this.props.defaultIndex}
          renderPagination={this.renderPagination}
          onMomentumScrollEnd={(e, state) => {
            if (this.isToTintStatusBar()) {
              StatusBar.setBackgroundColor(
                this.shadeStatusBarColor(this.props.pageArray[state.index].backgroundColor, -0.3),
                false,
              );
            }

            this.props.onSlideChange(state.index, state.total);
          }}
          onScroll={Animated.event([{ x: this.state.parallax }])}
        >
          {pages}
        </Swiper>
      </View>
    );
  }
}
